export default {"src":"/_next/static/media/404.d730ab9b.svg","height":202,"width":209,"blurWidth":0,"blurHeight":0};